module.exports = __webpack_public_path__ + "img/nabl_main0.6f80c886.jpg";